import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'
import { FnsLink } from 'Pages/registratorCabinet'

export const fnsApi = {
	getContainerRaspiskaRbidosRequest: async (id: number | string) => {
		const res = await axiosDS().get<FnsLink>(
			`${urls.cabinet.rbidosRequest}/${id}/container/raspiska`
		)
		return res.data
	},
	getContainerResponseRbidosRequest: async (id: number | string) => {
		const res = await axiosDS().get<SimpleResponse>(
			`${urls.cabinet.rbidosRequest}/${id}/container/response`
		)
		return res.data
	},
}
